import { useTabsComponents } from '@/next/utils/useTabsComponents';
import { cn } from '@skand/ui';

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabViewProps {
  tabs: Tab[];
}

export const TabView = ({ tabs }: TabViewProps) => {
  const { Tabs, TabsList, TabsTrigger, TabsContent } = useTabsComponents();

  return (
    <div
      className={cn(
        'border-neutral-400',
        'border-1',
        'rounded-6px',
        'border-solid',
        'w-full',
        'flex',
        'flex-col',
        'p-3',
      )}
    >
      <Tabs defaultValue={tabs[0].label}>
        <TabsList className="mb-3">
          {tabs.map(tab => (
            <TabsTrigger key={tab.label} value={tab.label}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabs.map(tab => (
          <TabsContent key={tab.label} value={tab.label}>
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
